import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IFilterTimeline } from '@app/shared/services/timeline/timeline.service';

@Component({
  selector: 'app-timeline-filter',
  templateUrl: './timeline-filter.component.html',
  styleUrls: ['./timeline-filter.component.sass'],
})
export class TimelineFilterComponent implements OnInit {
  @Output() exportClick = new EventEmitter();
  filterForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      idTrade: ['', []],
    });
  }

  exportFile(data: IFilterTimeline) {
    this.exportClick.emit(data);
  }
}
